module.exports = __webpack_public_path__ + "resources/img/equipment_tab2_img5.1a010d192246ccf079db84d60df0fc5d.jpg";